// extracted by mini-css-extract-plugin
export default {"message":"style_message__D3fEU"};